<script>
export default {
  props: {
    detail: {
      type: Object,
      required: true,
    },
  },
}
</script>

<template>
  <div class="rating-container">
    <div class="left-container">
      <div class="heart-container">
        <img
            v-for="(_, index) in new Array(detail.ratings)"
            :key="'selected-' + index"
            src="https://storage.healthathome.in.th/9d007bc3-fe10-49da-aeba-609b3e444e6f.svg"
            alt="selected"
        />
        <img
            v-for="(_, index) in new Array(5 - detail.ratings)"
            :key="'not-selected-' + index"
            src="https://storage.healthathome.in.th/f4ce9684-89c7-48b5-9061-d3e02d08dba1.svg"
            alt="not-selected"
        />
      </div>
      <div class="number-heart-container">
        <span class="number">{{ detail.ratings }}</span>
        <span class="unit">คะแนนหัวใจ</span>
      </div>
    </div>
    <div class="right-container">
      <div
          class="feedback-container"
          style="border-bottom: 1.5px solid #E9EAED;"
      >
        <img src="https://storage.healthathome.in.th/90c6c3fc-2030-48ed-b390-eb28e8fe2d60.svg" alt="good" width="24" height="24"/>
        <div class="number-feedback-container">
          <span class="number">{{ detail.goodFeedbacks }}</span>
          <span class="unit">ฟีดแบ็คดี</span>
        </div>
      </div>
      <div class="feedback-container">
        <img src="https://storage.healthathome.in.th/bec2abe4-2ad7-478e-af19-d1b5b8ba6dd0.svg" alt="bad" width="24" height="24"/>
        <div class="number-feedback-container">
          <span class="number">{{ detail.badFeedbacks }}</span>
          <span class="unit">ฟีดแบ็คไม่ดี</span>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.rating-container {
  display: grid;
  grid-template-columns: 240px 160px;
  height: 194px;

  .left-container {
    border-radius: 8px 0px 0px 8px;
    background-color: #5489FF;
    padding: 16px 24px 16px 16px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .heart-container {
      display: flex;
      flex-direction: row;
      gap: 4px;
    }

    .number-heart-container {
      display: flex;
      flex-direction: row;
      align-items: baseline;
      gap: 8px;

      .number {
        color: #FFF;
        font-family: "Sukhumvit-Bold";
        font-size: 32px;
        font-style: normal;
        font-weight: 700;
        line-height: 33px;
      }

      .unit {
        color: #FFF;
        font-family: "Sukhumvit-SemiBold";
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: 33px;
      }
    }
  }

  .right-container {
    border-radius: 0px 8px 8px 0px;
    border-top: 1.5px solid #E9EAED;
    border-right: 1.5px solid #E9EAED;
    border-bottom: 1.5px solid #E9EAED;
    display: grid;
    grid-template-rows: 1fr 1fr;

    .feedback-container {
      padding: 16px 24px 8px 16px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .number-feedback-container {
        display: flex;
        flex-direction: row;
        align-items: baseline;
        gap: 8px;

        .number {
          color: #434B61;
          font-family: "Sukhumvit-Bold";
          font-size: 32px;
          font-style: normal;
          font-weight: 700;
          line-height: 33px;
        }

        .unit {
          color: #434B61;
          font-family: "Sukhumvit-SemiBold";
          font-size: 14px;
          font-style: normal;
          font-weight: 600;
          line-height: 33px;
        }
      }
    }
  }
}
</style>
